// extracted by mini-css-extract-plugin
export default {"confirmDialogOverlay":"ConfirmDialog_confirmDialogOverlay__sXzp9","confirmDialog":"ConfirmDialog_confirmDialog__+FNcm"};